import { QuestionCircleOutlined } from '@ant-design/icons';
import { Radio, RadioChangeEvent, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState } from 'react';
import i18n from '@/i18n';
import style from './index.module.scss';

export enum RiskType {
  Serious = '严重',
  Warn = '警告',
  Hint = '提示',
  All = '所有',
}


export interface IRiskCount {
  serious: number;
  warn: number;
  hint: number;
  all: number;
}

interface IProps {
  initialValue?: string;
  onChange: (value: RiskType) => void;
  count?: IRiskCount;
}

export const RiskTypeSelector: FC<IProps> = observer((props) => {
  const [riskType, setRiskType] = useState<string>(props.initialValue || RiskType.All);

  useEffect(() => {
    if (props.initialValue) {
      setRiskType(props.initialValue);
    }
  }, [props.initialValue]);

  const onRadioGroupChange = (e: RadioChangeEvent) => {
    const riskType = e.target.value;
    setRiskType(riskType);
    props.onChange(riskType);
  };

  return <div className={style.radioGroup}>
    <Tooltip
      className={style.radioTips}
      title={(<span>
        {i18n.t('严重问题：有明确规定且被通报过的红线问题，以及严重不规范问题，请务必整改。')}<br /><br />
        {i18n.t('警告问题：针对法务重点要求字段，进行最小必要进行治理，请于近期的版本内整改完毕。')}<br /><br />
        {i18n.t('提示问题：建议整改问题，请自行评估排期整改，降低风险概率。')}</span>)}
      mouseEnterDelay={1}
      placement={'topRight'}>
      <span>{i18n.t('问题级别 ')}{<QuestionCircleOutlined />}{' :'}</span>
    </Tooltip>
    <Radio.Group className={style.radioGroup} value={riskType} onChange={onRadioGroupChange}>
      <Radio.Button
        style={riskType === RiskType.Serious ? { backgroundColor: '#FFEBEC', color: '#DB3543', borderColor: '#DB3543' } : {}}
        className={style.radioButton}
        value={RiskType.Serious}>
        {`${i18n.t(RiskType.Serious)}(${props.count?.serious || 0})`}
      </Radio.Button>
      <Radio.Button
        style={riskType === RiskType.Warn ? { backgroundColor: '#FFF3EB', color: '#F57E22', borderColor: '#F57E22' } : {}}
        className={style.radioButton}
        value={RiskType.Warn}>
        {`${i18n.t(RiskType.Warn)}(${props.count?.warn || 0})`}
      </Radio.Button>
      <Radio.Button
        style={riskType === RiskType.Hint ? { backgroundColor: '#F0F6FF', color: '#0062FF', borderColor: '#0062FF' } : {}}
        className={style.radioButton}
        value={RiskType.Hint}>
        {`${i18n.t(RiskType.Hint)}(${props.count?.hint || 0})`}
      </Radio.Button>
      <Radio.Button
        style={riskType === RiskType.All ? { backgroundColor: '#EBF7FF', color: '#28A2FA', borderColor: '#28A2FA' } : {}}
        className={style.radioButton}
        value={RiskType.All}>
        {`${i18n.t(RiskType.All)}(${props.count?.all || 0})`}
      </Radio.Button>
    </Radio.Group>
  </div>;
});
